import { FileUtil } from '@xengage/gw-portals-util-js';

export default {
    // Platform FileUtil functions
    checkFileName: FileUtil.checkFileName,
    separateFilenameFromExtension: FileUtil.separateFilenameFromExtension
};
